// src/notificationService.js

import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Crea una notifica per un utente specifico.
 * @param {string} recipientId - L'ID dell'utente che deve ricevere la notifica.
 * @param {object} sender - L'oggetto utente (da userProfile) che ha generato la notifica.
 * @param {string} message - Il messaggio della notifica (es. "ha modificato il tuo turno del GIORNO").
 * @param {string} link - (Opzionale) Un link interno all'app (es. '/turni').
 */
export const createNotification = async (recipientId, sender, message, link = '/') => {
  // Evita di notificare un utente per un'azione compiuta da lui stesso
  if (!recipientId || !sender || recipientId === sender.uid) {
    return;
  }

  try {
    await addDoc(collection(db, 'notifications'), {
      recipientId,
      senderId: sender.uid,
      senderName: sender.name,
      message,
      link,
      isRead: false,
      timestamp: serverTimestamp(),
    });
  } catch (error)
  {
    console.error("Errore durante la creazione della notifica:", error);
  }
};